import React from 'react'

import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'

import Price from '@components/UI/Price/Price'
import { IApplicationState } from '@store'
import { selectEstimatedCPE, selectEstimatedCPECurrency } from '@store/submissions'
import Theme from '@theme'
import { H5 } from '@tribegroup'

interface ISubHeaderLabelEstimatedCPEProps {
  submissionId: number
}

export const SubHeaderLabelEstimatedCPE: React.FC<ISubHeaderLabelEstimatedCPEProps> = ({
  submissionId,
}) => {
  const { estimatedCpe, currency } = useSelector(
    (state: IApplicationState) => ({
      estimatedCpe: selectEstimatedCPE(state, submissionId),
      currency: selectEstimatedCPECurrency(state, submissionId),
    }),
    shallowEqual,
  )

  return (
    <H5 color={Theme.grey700Color} uppercase inline light>
      {Boolean(estimatedCpe) && (
        <React.Fragment>
          <FormattedMessage id="submission.performance.estCpe" />
          &nbsp;
          <Price quantity={estimatedCpe} currency={currency} />
        </React.Fragment>
      )}
    </H5>
  )
}

export default SubHeaderLabelEstimatedCPE
